/**
 * The Projections V2 pages cache actuals, setup and seasonality in sessionStorage under
 * keys that start with PV2_SESSION_PREFIX and carry the projection id, not the user.
 * ProjectionV2Page reads a cached entry without calling the API, so AuthContext.logout
 * clears them: the next account to sign in on the tab would otherwise be shown them.
 */
export const PV2_SESSION_PREFIX = 'pv2-';

/** The key prefix of each cache; the projection id follows it. */
export const PV2_CACHE_PREFIXES = {
  actuals: `${PV2_SESSION_PREFIX}actuals-`,
  baseActuals: `${PV2_SESSION_PREFIX}base-actuals-`,
  seasonality: `${PV2_SESSION_PREFIX}seasonality-`,
  setup: `${PV2_SESSION_PREFIX}setup-`,
};

/**
 * Removes every PV2_SESSION_PREFIX entry and leaves every other key (MSAL's included).
 * @param {Storage} [storage] defaults to window.sessionStorage
 */
export function clearProjectionSessionCaches(storage) {
  try {
    const store = storage || window.sessionStorage;
    const keys = [];
    for (let i = 0; i < store.length; i += 1) {
      const key = store.key(i);
      if (key && key.startsWith(PV2_SESSION_PREFIX)) keys.push(key);
    }
    keys.forEach((key) => store.removeItem(key));
  } catch {
    // Storage blocked or unavailable: nothing was cached there.
  }
}
